module.exports = __webpack_public_path__ + "img/detail_img2.ad7b4397.jpg";